import { Fragment, FunctionComponent, h } from 'preact';
import Translate from '../translate/translate';
import { isNil as _isNil } from 'lodash';

interface Props {
	externalId: string;
}

const OrderExternalId: FunctionComponent<Props> = ({ externalId }) => {
	return (
		<div className="order-external-id">
			{!_isNil(externalId) ? (
				<Fragment>
					<Translate text="ORDER" /> #{externalId}
				</Fragment>
			) : null}
		</div>
	);
};

export default OrderExternalId;
